module.exports = __webpack_public_path__ + "static/img/guanwang23.fdedbaba.png";